import './libs/xml-js.min'

function _xml2js(xml, options) {
    let mdjs = xml2js(xml, options);
    return mdjs;
}

function _js2xml(js, options) {
    let mdxml = js2xml(js, options);
    return mdxml;
}

export default {
    xml2js: _xml2js,
    js2xml: _js2xml
}